export const FD_NODE_DRAG_START = 'FD_NODE_DRAG_START';
export const nodeDragStart = blockId => ({
  type: FD_NODE_DRAG_START,
  payload: blockId,
});

export const FD_SET_DRAG_TO_CONNECT_TARGET = 'FD_SET_DRAG_TO_CONNECT_TARGET';
export const setDragToConnectTarget = targetData => ({
  type: FD_SET_DRAG_TO_CONNECT_TARGET,
  payload: targetData,
});

export const FD_NODE_DRAG_STOP = 'FD_NODE_DRAG_STOP';
export const nodeDragStop = () => ({
  type: FD_NODE_DRAG_STOP,
});
